import React from 'react';
import { AdaptiveFilterBar } from '../../../../shared/components/patterns';

export default function DealsFiltersBar({
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Cerca...',
  hasActiveFilters,
  filters = [],
  onReset,
}) {
  const config = {
    search: {
      key: 'query',
      placeholder: searchPlaceholder,
    },
    groups: filters.map((filter) => ({
      key: filter.id,
      label: filter.placeholder || filter.label,
      selection: 'single',
      emptyValue: 'all',
      options: (filter.options || []).filter((option) => option.value !== 'all'),
    })),
  };

  const values = filters.reduce(
    (acc, filter) => ({
      ...acc,
      [filter.id]: filter.value,
    }),
    { query: searchValue }
  );

  return (
    <AdaptiveFilterBar
      config={config}
      values={values}
      hasActiveFilters={hasActiveFilters}
      onChange={(key, value) => {
        if (key === 'query') {
          onSearchChange(value);
          return;
        }

        const targetFilter = filters.find((filter) => filter.id === key);
        targetFilter?.onChange(value || 'all');
      }}
      onReset={onReset}
    />
  );
}
